export const moduleName = "modals";
import API from "@/api";
import Vue from 'vue';

export const actionTypes = {
  ACTION_INIT_WS: "ACTION_INIT_WS",
  ACTION_OPEN_MODAL: "ACTION_OPEN_MODAL",
  ACTION_CLOSE_MODAL: "ACTION_CLOSE_MODAL",
  ACTION_SET_MODAL_CONTENTS: "ACTION_SET_MODAL_CONTENTS",
  ACTION_CLOSE_CONFIRMATION_MODAL: "ACTION_CLOSE_CONFIRMATION_MODAL"
};

export const mutationTypes = {
  MUTATION_SET_MODAL: "MUTATION_SET_MODAL",
  MUTATION_SET_MODAL_CONTENTS: "MUTATION_SET_MODAL_CONTENTS",
  MUTATION_SET_CONFIRMATION_MODAL: "MUTATION_SET_CONFIRMATION_MODAL",
  MUTATION_SET_CONFIRMATION_MODAL_CONTENT:
    "MUTATION_SET_CONFIRMATION_MODAL_CONTENT"
};

export const getterTypes = {
  GETTER_OPENED_MODAL: "GETTER_OPENED_MODAL",
  GETTER_MODAL_CONTENTS: "GETTER_MODAL_CONTENTS",
  GETTER_OPENED_CONFIRMATION_MODAL: "GETTER_OPENED_CONFIRMATION_MODAL",
  GETTER_OPENED_CONFIRMATION_MODAL_CONTENTS:
    "GETTER_OPENED_CONFIRMATION_MODAL_CONTENTS"
};

export default {
  moduleName,

  namespaced: true,

  state: () => ({
    open: "",
    contents: {},
    confirmationOpen: false,
    confirmationContents: {}
  }),

  mutations: {
    [mutationTypes.MUTATION_SET_MODAL](state, modalType) {
      state.open = modalType;
    },
    [mutationTypes.MUTATION_SET_MODAL_CONTENTS](state, contents) {
      state.contents = contents;
    },
    [mutationTypes.MUTATION_SET_CONFIRMATION_MODAL](state, v = true) {
      state.confirmationOpen = v;
    },
    [mutationTypes.MUTATION_SET_CONFIRMATION_MODAL_CONTENT](state, contents) {
      state.confirmationContents = contents;
    }
  },

  actions: {
    [actionTypes.ACTION_INIT_WS]({ commit, getters, dispatch }) {
      console.log("model store ACTION_INIT_WS");
      const onGetComments = async ({value} ) => {
        console.log("onGetComments",value)
        let modelContent = getters[getterTypes.GETTER_MODAL_CONTENTS];
        console.log("modelContent",modelContent)
        if (
          modelContent &&
          modelContent.car &&
          value &&
          value.data &&
          value.data.id &&
          modelContent.id === value.data.id
        ) {
          Vue.set(modelContent, 'isLoading', false);
          modelContent.comments = value.data.comments;
          await dispatch(actionTypes.ACTION_SET_MODAL_CONTENTS, modelContent);
          let updateModelContent = getters[getterTypes.GETTER_MODAL_CONTENTS];
        }
        else if(modelContent && modelContent.type && value && value.data && value.data.type && value.data.type == modelContent.type){
          debugger
          if (
            modelContent &&
            modelContent.id &&
            value &&
            value.data &&
            value.data.id &&
            modelContent.id === value.data.id
          ) {
            Vue.set(modelContent, 'isLoading', false);
            modelContent.comments = value.data.comments;
            await dispatch(actionTypes.ACTION_SET_MODAL_CONTENTS, modelContent);
            let updateModelContent = getters[getterTypes.GETTER_MODAL_CONTENTS];
          }
        }
       
      };
      API.auctionManager.wsListeners[API.auctionManager.wsEvents.CAR_COMMENTS](
        onGetComments
      );
    },
    [actionTypes.ACTION_OPEN_MODAL]({ commit }, modalType) {
      commit(mutationTypes.MUTATION_SET_MODAL, modalType);
    },
    [actionTypes.ACTION_CLOSE_MODAL]({ commit }) {
      commit(mutationTypes.MUTATION_SET_MODAL, "");
    },
    [actionTypes.ACTION_CLOSE_CONFIRMATION_MODAL]({ commit }) {
      commit(mutationTypes.MUTATION_SET_CONFIRMATION_MODAL, false);
      setTimeout(() => {
        commit(mutationTypes.MUTATION_SET_CONFIRMATION_MODAL_CONTENT, {});
      }, 500);
    },
    [actionTypes.ACTION_SET_MODAL_CONTENTS]({ commit }, contents) {
      commit(mutationTypes.MUTATION_SET_MODAL_CONTENTS, contents);
    }
  },

  getters: {
    [getterTypes.GETTER_OPENED_MODAL]: state => state.open,
    [getterTypes.GETTER_MODAL_CONTENTS]: state => state.contents,
    [getterTypes.GETTER_OPENED_CONFIRMATION_MODAL]: state =>
      state.confirmationOpen,
    [getterTypes.GETTER_OPENED_CONFIRMATION_MODAL_CONTENTS]: state =>
      state.confirmationContents
  }
};
